import React, { useState, useEffect } from 'react'
import { Mutation } from 'react-apollo'
import { message } from 'antd'
import {
  P, H4, Div, InputWithLabel, Button,
} from 'konsys-ui'
import history from '../../history'
import PATH from '../../constants/path'
import VALIDATE from '../../constants/validate'
import { SIGNUP, RESEND_ACTIVATION } from '../../constants/graph/mutation'
import Container from '../../components/container'
import ReturnPage from '../../components/common/return-page'
import Banner from '../../images/member/banner.jpg'
import { theme, screenSize } from '../../styles/_variables'
import { getAccessToken } from '../../utils/local-data-service'
import {
  WidthContainer, ResendMail,
} from './styled'

const SuccessReturn = ({ email }) => (
  <Mutation
    mutation={RESEND_ACTIVATION}
  >
  {
    doResendActivation => (
      <ReturnPage
        title='ลงทะเบียนเพื่อสร้างบัญชีผู้ใช้'
        buttonData={[
          { title: 'กลับสู่หน้าแรก', style: 'inverse', link: PATH.home },
        ]}
      >
        <P display='block' textAlign='center' style={{ fontWeight: 'bold' }} color={theme.color.lightGrey}>คุณจะได้รับ Email เพื่อยืนยันการลงทะเบียนผู้ใช้ใหม่</P>
        <P display='block' textAlign='center' style={{ fontWeight: 'bold' }} color={theme.color.lightGrey}>กรุณายีนยันการลงทะเบียนผ่าน Email ของคุณ</P>
        <P margin='24px 0 0' display='block' textAlign='center' style={{ fontWeight: 'bold' }} color={theme.color.lightGrey}><ResendMail onClick={() => {
          doResendActivation({
            variables: {
              email,
            },
          }).then(({ data }) => {
            if (data.resendActivation) {
              if (data.resendActivation.success) {
                message.success(data.resendActivation.message)
              } else {
                message.error(data.resendActivation.message)
              }
            }
          })
        }}>คลิก</ResendMail> หากต้องการส่ง Email เพื่อยืนยันการลงทะเบียนใหม่อีกครั้ง</P>
      </ReturnPage>
    )
  }
  </Mutation>
)

const Register = () => {
  const [disabledButton, setDisabledButton] = useState(false)
  const [successMutation, setSuccessMutation] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [passwordConf, setPasswordConf] = useState('')
  const [windowSize, setWindowSize] = useState(window.innerWidth)

  useEffect(() => {
    if (getAccessToken()) {
      history.push(PATH.home)
    }
    window.addEventListener('resize', () => {
      setWindowSize(window.innerWidth)
    })
  })

  return (
    <Container header={{
      type: 'title',
      img: Banner,
      title: 'บัญชีผู้ใช้',
      color: theme.color.tertiaryColor,
    }}>
      <WidthContainer>
      {
        successMutation
          ? <SuccessReturn email={email} />
          : <Mutation
            mutation={SIGNUP}
          >
          {
            doSignup => (
              <Div>
                <H4 margin='0 0 32px' textAlign='center' display='block' color={theme.color.tertiaryColor}>ลงทะเบียนเพื่อสร้างบัญชีผู้ใช้</H4>
                <Div display='flex' flexDirection='column'>
                  <Div className='input'>
                    <InputWithLabel
                      title={{ text: 'Email', color: theme.color.primaryColor, bold: true }}
                      margin='0 0 24px'
                      input={{
                        state: email !== '' ? VALIDATE.email.test(email) ? 'success' : 'error' : '',
                        onChange: e => setEmail(e.target.value),
                        width: windowSize > screenSize.tablet ? '' : '100%',
                      }}
                    />
                  </Div>
                  <Div className='input'>
                    <InputWithLabel
                      title={{
                        text: 'รหัสผ่าน',
                        color: theme.color.primaryColor,
                        bold: true,
                      }}
                      input={{
                        message: 'กรุณากรอกรหัสผ่านอย่างน้อย 6 ตัวอักษรด้วยภาษาอังกฤษ ตัวเลข หรือสัญลักษณ์',
                        onChange: e => setPassword(e.target.value),
                        type: 'password',
                        width: windowSize > screenSize.tablet ? '' : '100%',
                        state: password !== '' ? VALIDATE.password.test(password) ? 'success' : 'error' : '',
                      }}
                    />
                  </Div>
                  <Div className='input'>
                    <InputWithLabel
                      title={{
                        text: 'รหัสผ่าน (อีกครั้ง)',
                        color: theme.color.primaryColor,
                        bold: true,
                      }}
                      input={{
                        message: 'กรุณากรอกรหัสผ่านใหม่ให้เหมือนกัน',
                        type: 'password',
                        width: windowSize > screenSize.tablet ? '' : '100%',
                        state: (password !== '' && passwordConf !== '') ? (password === passwordConf) ? 'success' : 'error' : '',
                        onChange: e => setPasswordConf(e.target.value),
                      }}
                    />
                  </Div>
                </Div>
                <Div>
                  <Button
                    disabled={disabledButton
                      || !VALIDATE.email.test(email)
                      || !VALIDATE.password.test(password)
                      || !VALIDATE.password.test(passwordConf)
                      || email === ''
                      || password === ''
                      || password !== passwordConf
                    }
                    loading={disabledButton}
                    margin='32px 0 0'
                    text='ลงทะเบียน'
                    color={theme.color.secondaryColor}
                    inverse
                    buttonStyle='round'
                    onClick={() => {
                      setDisabledButton(true)
                      doSignup({
                        variables: {
                          email,
                          password,
                        },
                      }).then(({ data }) => {
                        if (data.signup) {
                          if (data.signup.success) {
                            setSuccessMutation(true)
                          } else {
                            message.error(data.signup.message)
                          }
                          setDisabledButton(false)
                        }
                      })
                    }}
                  />
                </Div>
              </Div>
            )
          }
          </Mutation>
      }
      </WidthContainer>
    </Container>
  )
}

export default Register



// WEBPACK FOOTER //
// ./src/pages/register/index.jsx